<template>
  <div>
    <b-table
      striped
      hover
      thead-class="thead-table"
      :items="erogabili"
      :fields="fields"
      responsive
      stacked="lg"
    >
      <template v-slot:cell(reparto)="row">
        <!--<b-form-select
          :options="row.item.reparti"
          v-model="row.item.codicePrestazioneSelezionato"
          value-field="codicePrestazione"
          text-field="descrizionePrestazione"
          :disabled="isDisabled(row.item)"
          @change="selectHandler(row.item)"
        >
        </b-form-select>-->
        <b-form-input readonly v-model="row.item.descrizionePrestazione"></b-form-input>
      </template>
    </b-table>
  </div>
</template>
<script>
export default {
  props: {
    erogabili: Array,
    presaInCarico: Array
  },
  data() {
    return {
      fields: [
        {
          label: "Codice Catalogo",
          key: "codNazionale",
        },
        {
          label: "Prestazione",
          key: "desPrestazione",
        },
        {
          label: "Quantità",
          key: "quantita",
        }
      ],
    };
  },
  mounted: function () {
    let me = this;
    me.loadElement();
  },
  methods: {
    loadElement() {
      let me = this;
      me.presaInCarico.forEach((element) => {
        if (element.reparti.length > 1) {
          // Ci sono più prestazioni interne associate alla prestazione nazionale
          element.codicePrestazioneSelezionato = null;
          element.reparto = {
            codicePrestazione: null,
            descrizionePrestazione: null,
            idPrestazione: null,
          };
          element.reparti.push({
            descrizionePrestazione: "Seleziona la prestazione",
            codicePrestazione: null,
            idPrestazione: null,
          });
        } else {
          // C'è solo una prestazione interna associata alla prestazione nazionale
          element.codicePrestazioneSelezionato =
            element.reparti[0].codicePrestazione;
          element.descrizionePrestazione = element.reparti[0].descrizionePrestazione;
          element.reparto = {
            idPrestazione: element.reparti[0].idPrestazione,
            codicePrestazione: element.reparti[0].codicePrestazione,
            descrizionePrestazione: element.reparti[0].descrizionePrestazione,
          };
        }
      });
    },
    isDisabled(item) {
      return item.reparti.length === 1;
    },
    selectHandler(item) {
      item.reparti.forEach((prestazione) => {
        if (
          prestazione.codicePrestazione === item.codicePrestazioneSelezionato
        ) {
          item.reparto.idPrestazione = prestazione.idPrestazione;
          item.reparto.descrizionePrestazione =
            prestazione.descrizionePrestazione;
          item.reparto.codicePrestazione = item.codicePrestazioneSelezionato;
        }
      });
    },
  },
};
</script>

<style></style>
